module.exports = __webpack_public_path__ + "ne.e852679cbac90bd28070.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ne.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ne.svg
// module chunks = styles